import PreviewSidebar from "containers/admin/clients/client/theme-page/preview/preview-sidebar/preview-sidebar";
import PreviewArea from "containers/admin/clients/client/theme-page/preview/preview-area/preview-area";
import BannerSectionContent from "containers/admin/clients/client/theme-page/preview/sub-tabs/banner/banner-section-content";

const Banner = () => {
  return (
    <>
      <PreviewSidebar
        sidebarItems={[{ titleText: "THEME BANNER", children: <BannerSectionContent /> }]}
      />
      <div className="flex-1 overflow-auto custom-scroll ">
        <PreviewArea />
      </div>
    </>
  );
};

export default Banner;
